import { useEffect, useState } from "react";
import img from '../assets/profile.webp'

const stripAt = (handle: string) => (handle.startsWith("@") ? handle.slice(1) : handle);

type Stage = "unavatar" | "src" | "placeholder";

export const ProfilePicture = ({ src, twitterHandle }: { src?: string; twitterHandle?: string | null }) => {
  const handle = twitterHandle ? stripAt(twitterHandle) : null;
  const resolveInitial = (): Stage => (handle ? "unavatar" : src ? "src" : "placeholder");
  const [stage, setStage] = useState<Stage>(resolveInitial);

  useEffect(() => {
    setStage(resolveInitial());
  }, [src, handle]);

  const onError = () => {
    if (stage === "unavatar" && src) {
      setStage("src");
    } else {
      setStage("placeholder");
    }
  };

  const currentSrc =
    stage === "unavatar" && handle ? `https://unavatar.io/x/${handle}` : stage === "src" ? src : null;

  return (
    <div className="w-full h-full rounded-full overflow-hidden">
      <div className="w-full h-full aspect-square bg-black/10">
        {currentSrc ? (
          <img
            key={stage}
            src={currentSrc}
            className="w-full h-full rounded-full object-contain"
            onError={onError}
          />
        ) : (
          <img src={img} className="w-full h-full object-contain" />
        )}
      </div>
    </div>
  )
}
